import { getCatalogZones as getAllCatalogZones } from '/@/store/catalog/selectors';
import { getBrands } from '/@/store/public-data/selectors';

import { getAppInstance, getSessionCountry } from '/@/store/session/selectors';

const getProductDatasheetConfigurationsByAppInstance = (state, productDatasheetConfigs) => {
    const appInstance = getAppInstance(state);
    return productDatasheetConfigs.filter((productDatasheet) => productDatasheet.appInstanceId == appInstance.id);
};

export const getProductDatasheetBrands = (state, productDatasheetConfigs) => {
    const productDatasheetsBrands = getProductDatasheetConfigurationsByAppInstance(state, productDatasheetConfigs).map(
        (productDatasheet) => productDatasheet.brandId
    );
    return getBrands(state).filter((brand) => productDatasheetsBrands.includes(brand.id));
};

export const getProductDatasheetBrand = (state, props, productDatasheetConfigs) => {
    return getProductDatasheetBrandsByType(state, props, productDatasheetConfigs);
};

const getProductDatasheetBrandsByType = (state, props, productDatasheetConfigs) => {
    const { type, slug } = props;
    return getProductDatasheetBrands(state, productDatasheetConfigs).find(
        (productDatasheetBrand) => productDatasheetBrand.type === type && productDatasheetBrand.slug === slug
    );
};

const getZoneId = (state) => state.productDatasheet.zone;

export const getZone = (state, props, brand, catalogZones) => {
    const zone = getZoneId(state);
    const zones = getZones(state, props, brand, catalogZones);
    return zones.find(({ id }) => id === zone);
};

export const getZones = (state, props, brand, catalogZones) => {
    if (!brand) return [];
    const { type } = props;
    const zones = getAllCatalogZones(state, brand.type, 'catalog', catalogZones);
    const country = getSessionCountry(state);
    return zones.filter((zone) => zone.countryId == country.id && zone.crop === type);
};

export const getProductDatasheetConfig = (state, props, productDatasheetConfigs) => {
    const brand = getProductDatasheetBrand(state, props, productDatasheetConfigs);
    if (!brand) return;
    return productDatasheetConfigs.find((config) => config.brandId == brand.id);
};

export const getProductDatasheetEnvironmentRangeForProfile = (state) => {
    return state.productDatasheet.selectedEnvironmentRanges || {};
};

export const getMetric = (state, metrics) => {
    if (!metrics) return {};
    const metricId = state.productDatasheet.metric;
    return metrics.find(({ id }) => id === metricId) || metrics[0];
};

export const getSelectedIds = (state) => {
    return state.productDatasheet.selectedIds || [];
};

export const getProductDatasheet = (state, props) => {
    return state.productDatasheet || {};
};

export const getSelectedModulesIds = (state) => {
    return state.productDatasheet.modulesIds || [];
};

export const getSelectedExtrasIds = (state) => {
    return state.productDatasheet.extrasIds || [];
};

export const getSelectedEnvironmentRange = (state, id) => {
    if (state.productDatasheet.selectedEnvironmentRanges) {
        return state.productDatasheet.selectedEnvironmentRanges[id] || undefined;
    }
    return undefined;
};

export const getCropType = (state) => {
    return state.productDatasheet.type;
};

export const getSelectedFeaturesIds = (state) => {
    return state.productDatasheet.featuresIds || [];
};

export const getSelectedMetricsIds = (state) => {
    return state.productDatasheet.metricsIds || [];
};

export const getCompletePreview = (state) => {
    return state.productDatasheet.completePreview || [];
};
